import { Tab } from "react-bootstrap";
import { Container, CustomTabs, TabTitleComContador } from "./style";
import { useEffect, useState } from "react";
import { TabAguardandoAprovacao } from "./TabAguardandoAprovacao";
import { TabAprovadosPagamento } from "./TabAprovadosPagamento";
import { TabReprovados } from "./TabReprovados";
import { useGerenciarPagamentos } from "../../hooks/useGerenciarPagamentos";
import usePermissoes from "hooks/usePermissoes";
import { CriarLote } from "../CriarLote";
import { EditarLote } from "../EditarLote";

function ContadorAba({ valor }: { valor: number | null }) {
  if (typeof valor !== "number") return null;
  return <span> ({valor})</span>;
}

export function TabsGerenciarPagamentos() {
  const [tela, setTela] = useState<"gerenciar" | "criar" | "editar">("gerenciar");
  const [aba, setAba] = useState<string>("aguardando");
  const [idLoteEditar, setIdLoteEditar] = useState<number | null>(null);
  const {
    buscarContadores,
    contadorAguardando,
    contadorAprovados,
    contadorReprovados,
  } = useGerenciarPagamentos();
  const { listaPermissoes } = usePermissoes();

  useEffect(() => {
    buscarContadores();
  }, []);

  const onSelectAba = (e: string | null) => {
    if (e) setAba(e);
  };

  if (tela === "criar") {
    return (
      <CriarLote
        onCancelar={() => setTela("gerenciar")}
        onSalvar={() => {
          setTela("gerenciar");
          buscarContadores();
        }}
      />
    );
  }

  if (tela === "editar" && idLoteEditar) {
    return (
      <EditarLote
        idLote={idLoteEditar}
        onVoltar={() => {
          setTela("gerenciar");
          setIdLoteEditar(null);
        }}
        onSalvar={(status) => {
          setTela("gerenciar");
          setIdLoteEditar(null);
          buscarContadores();
          if (status) {
            const abaMap: Record<string, string> = {
              APROVADO: "aprovados",
              REPROVADO: "reprovados",
            };
            setAba(abaMap[status] ?? "aguardando");
          }
        }}
      />
    );
  }

  return (
    <Container>
      <CustomTabs defaultActiveKey="aguardando" activeKey={aba} onSelect={onSelectAba}>
        <Tab
          eventKey="aguardando"
          title={
            <TabTitleComContador>
              Aguardando aprovação
              <ContadorAba valor={contadorAguardando} />
            </TabTitleComContador>
          }
          style={{ color: "black" }}
        >
          <TabAguardandoAprovacao
            aba={aba}
            onAtualizarContadores={buscarContadores}
            onCriarLote={() => setTela("criar")}
            listaPermissoes={listaPermissoes}
          />
        </Tab>

        <Tab
          eventKey="aprovados"
          title={
            <TabTitleComContador>
              Aprovados para pagamento
              <ContadorAba valor={contadorAprovados} />
            </TabTitleComContador>
          }
          style={{ color: "black" }}
        >
          <TabAprovadosPagamento
            aba={aba}
            onAtualizarContadores={buscarContadores}
            listaPermissoes={listaPermissoes}
          />
        </Tab>

        <Tab
          eventKey="reprovados"
          title={
            <TabTitleComContador>
              Reprovados
              <ContadorAba valor={contadorReprovados} />
            </TabTitleComContador>
          }
          style={{ color: "black" }}
        >
          <TabReprovados
            aba={aba}
            onAtualizarContadores={buscarContadores}
            onEditarLote={(idLote) => {
              setIdLoteEditar(idLote);
              setTela("editar");
            }}
            listaPermissoes={listaPermissoes}
          />
        </Tab>
      </CustomTabs>
    </Container>
  );
}
